import { PlanType } from '@dtx-company/true-common/src/types/planType'

export interface ProUpgradeModalContainerState {
  onPaymentSuccess: () => void
  handleClose: () => void
  planTypeUpgradingTo: PlanType
}

export enum ProUpgradeSourceIds {
  BULK_CODE_CREATION = 'bulk-code-creation',
  CODE_CREATION_ADDITIONAL_COLORS = 'code-creation-additional-colors', // Soon to be depracated, once hex is released. - AF
  CODE_CREATION_HEX_COLORS = 'code-creation-hex-colors',
  CODE_MANAGEMENT_CREATE_CODE = 'code-management-create-code',
  CODE_MANAGEMENT_DUPLICATE_CODE = 'code-management-duplicate-code',
  CODE_MANAGEMENT_FOLDER_CREATE_CODE = 'code-management-folder-create-code',
  CODE_MANAGEMENT_FOLDER_ROW_DUPLICATE_CODE = 'code-management-folder-row-duplicate-code',
  CODE_MANAGEMENT_MOBILE_FAB_CREATE_CODE = 'code-management-mobile-fab-create-code',
  CODE_MANAGEMENT_RESTORE_DELETED_CODE = 'code-management-restore-deleted-code',
  DASHBOARD_PRO_UPSELL_CARD = 'dashboard-pro-upsell-card',
  FLOWPAGE_CREATION_ADDITIONAL_COLORS = 'flowpage-creation-additional-colors',
  FLOWPAGE_CREATION_ADDITIONAL_COLORS_MOBILE = 'flowpage-creation-additional-colors-mobile',
  LEFT_NAV_CREATE_CODE = 'left-nav-create-code',
  LEFT_NAV_CREATE_PAGE = 'left-nav-create-page',
  PAGES_CREATE_PAGE = 'pages-create-page',
  FLOWPAGE_CHANGE_FONT = 'flowpage-change-font',
  FLOWPAGE_STYLE_FONT = 'flowpage-style-font',
  FLOWPAGE_CRM_INTEGRATIONS = 'flowpage-crm-integrations',
  FLOWPAGE_CRM_CUSTOM_FIELD = 'flowpage_crm_custom_field',
  FLOWPAGE_CRM_CUSTOM_TERMS = 'flowpage_crm_custom_terms',
  FLOWPAGE_SSO_MAX_PAGES = 'flowpage-sso-max-pages',
  FLOWPAGE_DUPLICATE_PAGE = 'flowpage-duplicate',
  PLANS_PAGE_QUERY_PARAM = 'plans-page-query-param',
  PLANS_PLUS_PAGE_QUERY_PARAM = 'plans-plus-page-query-param',
  PLANS_PAGE_PRO_SIGN_UP = 'plans-page-pro-sign-up',
  PRINT_STORE_PDP_CREATE_CODE = 'print-store-pdp-create-code',
  PRINT_STORE_DISCOUNT_UPSELL = 'print-store-discount-upsell',
  PRO_LANDING_PAGE_ANALYTICS = 'pro-landing-page-analytics',
  PRO_LANDING_PAGE_BULK_CREATION = 'pro-landing-page-bulk-creation',
  PRO_LANDING_PAGE_BULK_CREATION_MOBILE = 'pro-landing-page-bulk-creation-mobile',
  PRO_LANDING_PAGE_CUSTOM_DESIGN = 'pro-landing-page-custom-design',
  PRO_LANDING_PAGE_CUSTOM_DESIGN_MOBILE = 'pro-landing-page-custom-design-mobile',
  PRO_LANDING_PAGE_FLOWPAGE = 'pro-landing-page-flowpage',
  PRO_LANDING_PAGE_FOOTER = 'pro-landing-page-footer',
  PRO_LANDING_PAGE_GET_STARTED = 'pro-landing-page-get-started',
  PRO_LANDING_PAGE_QUERY_PARAM = 'pro-landing-page-query-param',
  PRO_LANDING_PAGE_RULE_BASED = 'pro-landing-page-rule-based',
  PRO_UPSELL_CARD = 'pro-upsell-card',
  STARTER_KIT_LANDING_PAGE = 'starter-kit-landing-page',
  FLOWPAGE_DEINDEX_FROM_GOOGLE = 'flowpage-deindex-from-google',
  CODE_FREE_TEXT_RIM = 'free-text-rim',
  CODE_FREE_TEXT_CENTER = 'free-text-center',
  FLOWPAGE_PRO_CRM_INTEGRATION = 'flowpage-pro-crm-integration',
  NAV_STORAGE_SECTION = 'nav-storage-section',
  NAV_MOBILE_MORE_MENU = 'nav-mobile-more-menu',
  ASSET_CREATION_MODAL = 'asset-creation-modal',
  PLATFORM_FEATURE_LANDING_PAGE = 'platform-feature-landing-page',
  FLOWPAGE_PRO_REMOVE_WHITELABEL = 'flowpage-pro-remove-whitelabel',
  UNIFIED_ASSET_MANAGEMENT_DUPLICATE_CODE = 'unified-asset-management-duplicate-code',
  UNIFIED_ASSET_MANAGEMENT_DUPLICATE_PAGE = 'unified-asset-management-duplicate-page',
  UNIFIED_ASSET_MANAGEMENT_RESTORE_ASSETS = 'unified-asset-management-restore-assets'
}

export enum ProPlusUpgradeSourceIds {
  FLOWPAGE_CREATE_TEMPLATE_MENU = 'flowpage-create-template-menu',
  FLOWCODE_REMOVE_WHITELABEL = 'flowcode-pro-plus-remove-whitelabel',
  FLOWPAGE_SETTINGS_CREATE_TEMPLATE = 'flowpage-settings-create-template'
}
